import React, { ReactElement } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { RoutesArray } from 'ui/components/Navigation/types'
import { PrivateRoute } from './components/PrivateRoute/PrivateRoute'

type PrivateSwitchProps = {
  routes: RoutesArray
}

export function PrivateRoutes({ routes }: PrivateSwitchProps): ReactElement {
  const filteredRoutes = routes.flatMap((route) => (route.children ? route.children : route))

  return (
    <Routes>
      {filteredRoutes.map((route, key) => {
        if (route.redirect && route.to) {
          return <Route key={key} path={route.path} element={<Navigate replace to={route.to} />} />
        }

        return (
          <Route
            key={key}
            path={route.path}
            element={
              <PrivateRoute
                component={route.component}
                title={route.navbarName ? route.navbarName : undefined}
                key={key}
              />
            }
          />
        )
      })}
    </Routes>
  )
}

export default PrivateRoutes
